import { LocalShipping, VerifiedUser, Warehouse } from "@mui/icons-material";
import { Card, CardContent, Chip, Grid, LinearProgress, Link, Tooltip } from "@mui/material/";
import { cloneDeep } from "lodash";
import { memo, useEffect, useState, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
import Api from "../../Api";
import { Feature, PermissionContext } from "../../contexts/PermissionContext";
import { IMaterialAudit } from "../../interfaces";
import { EmptyContent } from "./EmptyContent";
import './index.scss';
import { WidgetHeader } from "./WidgetHeader";

export const AuditWidget = memo(() => {

    const permissionContext = useContext(PermissionContext);
    const permitted = () => {
        return permissionContext.isPermitted(Feature.Audit);
    }

    const hasRequests = () => {

        if (!permitted()) return false;

        if (materialAudits)
            return materialAudits.length > 0
        return false;
    }

    const [materialAudits, setmaterialAudits] = useState<IMaterialAudit[] | null>(null);
    const [dataLoading, setDataLoading] = useState(true);
    const [pending, setPending] = useState(false);



    useEffect(() => {
        if (dataLoading && !pending) {
            setPending(true);
            Api.Audits.getByStatus("open").then(x => {

                let list = cloneDeep(x as IMaterialAudit[]).reverse();

                setmaterialAudits(list);
                setDataLoading(false);
            });
        }
    })



    return (
        <Card elevation={3} className="dashboard-widget dashboard-widget-box">
            <WidgetHeader><VerifiedUser sx={{ mr: 1 }} /> Audits</WidgetHeader>
            <CardContent sx={{ height: "80%", overflowY: "auto", scrollbarWidth: "thin" }}>

                {dataLoading ? <LinearProgress /> :

                    hasRequests() ?
                        <ul className="widget-list">
                            {materialAudits && materialAudits.map((s, i) => {



                                return <li key={i}>
                                    <Tooltip title={`${s.reference ?? "No Reference"} (${s.dateCreated && new Date(s.dateCreated).toLocaleDateString("en-GB")})`}>
                                        <Link
                                            component={RouterLink}
                                            to={"/audit/update/" + s.materialAuditId}>
                                            <Grid container justifyContent="space-between">
                                                <span>{s.reference ?? "No Reference"}</span>
                                                <Chip
                                                    label={s.statusName}
                                                    variant="outlined"
                                                    color="primary"
                                                />
                                            </Grid>

                                        </Link>
                                    </Tooltip>
                                </li>
                            })



                            }
                        </ul>
                        :

                        <EmptyContent
                            contentType={"audits" + (permitted() ? "" : " (You do not have permission to view audits)")}
                            icon={<VerifiedUser fontSize="inherit" />}
                        />
                }

            </CardContent>
        </Card >
    );

});
